module.exports = __webpack_public_path__ + "media/images/sec_3-6-c16911e8a1020ef802d93252b733c0f6.png";